// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__yL09B","requiredAsterisk":"Info_requiredAsterisk__dFVE_"};